'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var COLORS = {
  IO_AQUA: '#66c2ce',
  IO_COBALT: '#009ee2',
  IO_RUSTY: '#84C2CC',
  IO_STEEL: '#366d93',
  IO_NAVY: '#001760',
  SUCCESS: '#009A5D',
  WARNING: '#F6A624',
  DANGER: '#E20621'
};
exports.default = COLORS;